export const CHANNEL_VIDEO_CREATE = "/channel/video/create/";
export const CHANNEL_VIDEO_UPDATE = "/channel/video/update";
export const CHANNEL_VIDEO_ADD = "/channel/video/add";
export const CHANNEL_VIDEO_DETAILS = "/channel/video/detail/";
export const CHANNEL_VIDEO_EDIT = "/channel/video/edit/";
export const CHANNEL_EDIT_GET = "/channel/edit_channel/";
export const CHANNEL_REACH_GET = "/channel/reach/";
export const CHANNEL_VIDEO_UPDATE_BASIC = "channel/video/update_basic";
export const CHANNEL_NAME_CHECK = "/channel/check_channel";
